import ApiCrud from "./api-crud";

class PresupuestoService extends ApiCrud {
  resource = "presupuestos";
  primaryKey = "idpresupuesto";
}

export default new PresupuestoService();
